import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import { Box, Link, Typography } from "@mui/material"
import UploadComponent from "src/v2/components/upload/upload-component"
import {
    getCompanyImportValidation,
    useCompanyBulkImport,
} from "./use-company-bulk-import"

const CompanyBulkImport = ({ onImported }) => {
    const fileInputRef = useRef(null)
    const [uploadKey, setUploadKey] = useState(0)
    const {
        isImporting,
        uploadError,
        selectFile,
        importFile,
    } = useCompanyBulkImport({ onImported })

    const handleSendFile = async () => {
        const imported = await importFile()

        if (imported) setUploadKey((currentKey) => currentKey + 1)
    }

    return (
        <Box component="section" aria-labelledby="company-bulk-import-title" sx={{ pt: 3 }}>
            <Typography
                id="company-bulk-import-title"
                component="h2"
                variant="subtitle1"
                sx={{ color: "icon.white70", mb: 1.5 }}
            >
                Cadastro em lote
            </Typography>
            <Box sx={{ mb: 2, maxWidth: 880 }}>
                <Typography variant="textBody" sx={{ color: "primary.white70", lineHeight: 1.6 }}>
                    Use o cadastro em lote como alternativa ao preenchimento manual. Baixe o arquivo de {" "}
                    <Link href="/example/ExemploContraparte.xlsx" color="inherit" underline="always">
                        Exemplo
                    </Link>{" "}
                    e faça o upload abaixo.
                </Typography>
            </Box>
            <UploadComponent
                key={uploadKey}
                variant="guided"
                accept=".xlsx,.csv"
                fileInputRef={fileInputRef}
                onFileSelect={selectFile}
                validateFile={(file) => getCompanyImportValidation(file).valid}
                onFileRejected={selectFile}
                onSendFile={handleSendFile}
                isSending={isImporting}
                sendLabel={isImporting ? "IMPORTANDO..." : "IMPORTAR"}
                buttonLabel="SELECIONAR ARQUIVO"
                helperText="ou selecione um arquivo do seu computador"
                formatHint="Formatos suportados: .xlsx ou .csv"
            />
            {uploadError && (
                <Typography role="alert" sx={{ color: "error.main", mt: 1 }}>
                    {uploadError}
                </Typography>
            )}
        </Box>
    )
}

CompanyBulkImport.propTypes = {
    onImported: PropTypes.func,
}

CompanyBulkImport.defaultProps = {
    onImported: null,
}

export default CompanyBulkImport
